import { PartialTranslation } from '../translations';

export const az: PartialTranslation = {
  newChat: 'Yeni söhbət',
  search: 'Axtarış',
  user: 'İstifadəçi',
  settings: 'Tənzimləmələr',
  language: 'Dil',
  getHelp: 'Kömək al',
  viewAllPlans: 'Bütün planları gör',
  learnMore: 'Daha çox öyrən',
  logOut: 'Çıxış',
  chooseLanguage: 'Dil seç',
  chooseYourPreferredLanguage: 'Üstün tutduğunuz dili seçin',
  searchLanguages: 'Dil axtar...',
  autoDetect: 'Avtomatik aşkarlama',
  noLanguagesFound: 'Heç bir dil tapılmadı',
  askAnything: 'İstənilən şey soruş',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Şəxsi',
  freePlan: 'Pulsuz plan',
  current: 'Cari',
  close: 'Bağla',
  archive: 'Arxiv',
  delete: 'Sil',
  confirmDelete: 'Bu söhbəti silmək istədiyinizdən əminsiniz?',
  confirmArchive: 'Bu söhbəti arxivləmək istədiyinizdən əminsiniz?',
  deleteCannotUndo: 'Bu əməliyyatı geri qaytarmaq mümkün deyil.',
  archiveCanFind: 'Arxivlədikdən sonra arxiv siyahısında tapa biləcəksiniz.',
  resources: 'Resurslar',
  addResource: 'Resurs əlavə et',
  deleteResource: 'Resursu sil',
  noMatchingResourcesFound: 'Uyğun resurs tapılmadı',
  noResourcesAvailable: 'Heç bir resurs mövcud deyil',
  hideResources: 'Resursları gizlət',
  showResources: 'Resursları göstər',
  typeMessage: 'Mesaj yaz...',
  thinkingOptions: 'Düşüncə variantları',
  deleteFile: 'Faylı sil',
  clearSelection: 'Seçimi təmizlə',
  addAttachment: 'Əlavə et',
  sendMessage: 'Mesaj göndər',
  deepInsight: 'Dərin anlayış · Səth təhlili',
  deepInsightDesc: 'Əsas nöqtələrin sürətli anlaşılması',
  deepExploration: 'Dərin tədqiqat · Hərtərəfli təhlil',
  deepExplorationDesc: 'Çoxölçülü dərin araşdırma',
  deepDeconstruction: 'Dərin dekonstruksiya · Sistemli arqument',
  deepDeconstructionDesc: 'Qat-qat mütərəqqi təhlil',
  contractReview: 'Müqavilənin baxışı · Risk müəyyənləşdirilməsi',
  contractReviewDesc: 'Bəndlərin təhlili və uyğunluq yoxlanılması',
  textPolish: 'Mətn cilalanması · Peşəkar ifadə',
  textPolishDesc: 'Dil optimallaşdırılması və struktur tənzimlənməsi',
  legalDocuments: 'Hüquqi sənədlər · Standart layihə',
  legalDocumentsDesc: 'Peşəkar hüquqi sənəd yazılışı',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Daxil ol',
  register: 'Qeydiyyat',
  welcomeBack: 'LawHelper-ə xoş gəlmisiniz',
  loginSubtitle: 'Sizin AI hüquqi araşdırma köməkçiniz',
  continueWithGoogle: 'Google ilə davam et',
  continueWithMicrosoft: 'Microsoft ilə davam et',
  continueWithWeChat: 'WeChat ilə davam et',
  orContinueWith: 'və ya davam et',
  emailTab: 'E-poçt',
  phoneTab: 'Telefon',
  emailPlaceholder: 'E-poçtunuzu daxil edin',
  phonePlaceholder: 'Telefon nömrəsini daxil edin',
  codePlaceholder: '6 rəqəmli kodu daxil edin',
  sending: 'Göndərilir...',
  verifying: 'Yoxlanılır...',
  verify: 'Təsdiqlə',
  sendMagicLink: 'Sehrli keçid göndər',
  getVerificationCode: 'Kod al',
  resendCode: 'Kodu yenidən göndər',
  resendIn: 'Yenidən göndər',
  magicLinkSent: 'Sehrli keçid e-poçtunuza göndərildi',
  magicLinkHint: 'Biz e-poçtunuza təhlükəsiz keçid göndərəcəyik',
  otpSent: 'Təsdiq kodu göndərildi',
  agreeToTerms: 'Davam etməklə siz razılaşırsınız',
  privacyPolicy: 'Məxfilik Siyasəti',
  termsOfService: 'Xidmət Şərtləri',
  and: 'və',
  privacyTitle: 'Məxfiliyiniz vacibdir',
  privacyIntro: 'Ən yaxşı təcrübəni təmin etmək üçün kukilər və oxşar texnologiyalardan istifadə edirik.',
  essentialCookies: 'Zəruri kukilər',
  essentialDesc: 'Veb saytın işləməsi üçün lazımdır',
  analyticsCookies: 'Analitik kukilər',
  analyticsDesc: 'Xidməti yaxşılaşdırmağa kömək edir',
  marketingCookies: 'Marketinq kukiləri',
  marketingDesc: 'Fərdi məzmun üçün istifadə olunur',
  acceptAll: 'Hamısını qəbul et',
  essentialOnly: 'Yalnız zəruri',
  customize: 'Fərdiləşdir',
  savePreferences: 'Parametrləri saxla',
  back: 'Geri',
  readPrivacyPolicy: 'Məxfilik siyasətimizi oxuyun',
  cookiePolicy: 'Kuki Siyasəti',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'AI yoxlama',
  aiDraft: 'AI qaralama',
  smartAssistant: 'Şablon',

  // 知识库搜索
  enableKnowledgeSearch: 'Axtarışı aktivləşdir',
  knowledgeSearchDesc: 'AI sənədlərinizdə axtarır',
  clickToDisable: 'Deaktiv et',
  clickToEnable: 'Aktivləşdir',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Resurs panelini bağla',
  uploading: '%{fileName} yüklənir...',
  processing: '%{fileName} emal edilir...',
  uploadSuccess: '✓ %{fileName} yükləndi',
  uploadError: '✗ Yükləmə uğursuz: %{error}',
  quickAnswer: 'Sürətli Cavab',
  quickAnswerDesc: 'Sadə suallara sürətli cavab',
  cancelRequest: 'Ləğv et',
  library: 'Kitabxana',
  filterAll: 'Hamısı',
  filterChat: 'Söhbətlər',
  filterReview: 'Nəzərdən keçirmə',
  filterDraft: 'Qaralama',
  filterTemplate: 'Şablon',
  filterForm: 'Forma',
  thinking: 'Düşünür...',
  thinkingProcess: 'Thinking Process',
  analyzingLegalLogic: 'Analyzing legal logic...',
  lawhelperThinking: 'Lawhelper is thinking...',
  serviceError: 'Xidmət xətası',
  uploaded: 'Yükləndi',
  settingsGeneral: 'Ümumi',
  settingsNotifications: 'Bildirişlər',
  settingsAppearance: 'Görünüş',
  settingsProfile: 'Profil',
  settingsResponseNotifications: 'Response Notifications',
  settingsResponseNotificationsDesc: 'Get notified when AI finishes a response',
  settingsColorMode: 'Rəng rejimi',
  settingsLight: 'Açıq',
  settingsDark: 'Tünd',
  settingsSystem: 'Sistem',
  about: 'Haqqında',
  reviewTitle: 'Sənəd nəzərdən keçirmə',
  exitReview: 'Exit Review',
  uploadPrompt: 'Upload PDF to start review',
  uploadButton: 'Select File',
  startChatConfig: 'Type "Review this document" to start',
  reviewPlaceholder: 'Type a message or "Review this document"...',
  analyzing: 'Nəzərdən keçirir...',
  reviewComplete: 'Nəzərdən keçirmə tamamlandı',
  issuesFound: 'Found %{count} issues',
  draftTitle: 'Hüquqi sənəd hazırlama',
  draftPlaceholder: 'Edit here or ask AI to generate...',
  analyzingTemplate: 'Analyzing template file %{name}...',
  templateAnalyzed: '✅ Template %{name} analyzed! Tell me how you want to modify or fill this template.',
  templateAnalysisPrompt: 'Analyze key clauses of this template',
  parsingFailed: '⚠️ Failed to parse file, but you can still describe your needs.',
  generating: 'Yaradılır...',
  generatedSuccess: '✅ Sənəd yaradıldı!',
  drafterWelcome: 'AI Sənəd Köməkçisinə xoş gəlmisiniz',
  drafterYouCan: 'You can:',
  drafterUploadTemplate: 'Upload a template for AI to analyze',
  drafterDescribeNeeds: 'Describe your document requirements',
  drafterLetAiHelp: 'Let AI help you draft contracts, agreements, etc.',
  drafterExamples: 'Nümunələr:',
  drafterExampleRental: '"Help me draft a rental agreement"',
  drafterExampleLabor: '"Fill in the labor contract based on template"',
  drafterInputPlaceholder: 'Ehtiyaclarınızı təsvir edin...',
  drafterThinking: 'Düşünür...',
  drafterHistoryTitle: 'Tarixçə',
  drafterNoHistory: 'Tarixçə yoxdur',
  drafterNewChat: 'Yeni söhbət',
  drafterHistory: 'History',
  drafterRemoveAttachment: 'Remove attachment',
  drafterLineHeight: 'Line Height',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Export as Word (.docx)',
  drafterExportPdf: 'Export as PDF',
  drafterSave: 'Sənədi saxla',
  drafterDownload: 'Sənədi yüklə',
  drafterUndo: 'Undo',
  drafterRedo: 'Redo',
  drafterBold: 'Bold',
  drafterItalic: 'Italic',
  drafterStrike: 'Strikethrough',
  drafterUnderline: 'Underline',
  drafterHighlight: 'Highlight',
  drafterLink: 'Insert Link',
  drafterAlignLeft: 'Align Left',
  drafterAlignCenter: 'Align Center',
  drafterAlignRight: 'Align Right',
  drafterAlignJustify: 'Justify',
  drafterList: 'List',
  drafterBulletList: 'Bullet List',
  drafterOrderedList: 'Ordered List',
  drafterTaskList: 'Task List',
  drafterOpenResource: 'Open Resources Panel',
  drafterStopGeneration: 'Stop generation',
  drafterAgentMode: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOn: 'Agent mode enabled | Click to switch to normal chat',
  drafterAgentModeOff: 'Normal chat mode | Click to switch to Agent mode',
  drafterUploadAttachment: 'Upload attachment',
  drafterExit: 'Çıx',
  drafterConfirm: 'Təsdiqlə',
  drafterOpenLink: 'Open link',
  drafterDeleteLink: 'Delete link',
  drafterQuote: 'Quote',
  workflowTitle: 'AI iş axını',
  workflowRunning: 'Running...',
  workflowReady: 'Hazır',
  workflowCompleted: 'Tamamlandı',
  workflowStartFailed: 'Workflow start failed',
  workflowExecutionFailed: 'Workflow execution failed',
  workflowInterrupted: 'Workflow interrupted',
  workflowProcessing: 'Processing...',
  workflowStepsCompleted: 'steps completed',
  workflowStepsTotal: 'Workflow completed (%{count} steps)',
  acceptChanges: 'Dəyişiklikləri qəbul et',
  rejectChanges: 'Dəyişiklikləri rədd et',
  changesAccepted: 'Changes accepted',
  changesRejected: 'Changes rejected',
  stopWorkflow: 'Dayandır',
  restartWorkflow: 'Restart',
  startDrafting: 'Hazırlamağa başla',
  interrupt: 'Stop',
  documentSubject: 'Sənəd mövzusu *',
  documentType: 'Sənəd növü',
  jurisdiction: 'Jurisdiction',
  specialRequirements: 'Special Requirements (optional)',
  clickStartDrafting: 'Click "Start Drafting" to begin workflow',
  docTypeContract: 'Müqavilə',
  docTypeAgreement: 'Razılaşma',
  docTypeNotice: 'Notice',
  docTypeLetter: 'Məktub',
  docTypePetition: 'Petition',
  docTypeWill: 'Will',
  docTypePowerOfAttorney: 'Power of Attorney',
  countryChina: 'Çin',
  countryUSA: 'ABŞ',
  countryGermany: 'Almaniya',
  countryJapan: 'Yaponiya',
  countryFrance: 'Fransa',
  countryUK: 'Böyük Britaniya',
  citationVerified: 'Verified',
  citationUnverified: 'Unverified',
  imageLoadFailed: 'Image failed to load',
  smartDocTitle: 'Ağıllı sənəd köməkçisi',
  smartDocChatTitle: 'AI Document Assistant',
  smartDocDropPrompt: 'Drop PDF file here',
  smartDocSelectFile: 'Fayl seç',
  smartDocOr: 'və ya',
  smartDocWelcomeTitle: 'Welcome to AI Document Assistant',
  smartDocWelcomeYouCan: 'You can:',
  smartDocUploadForAI: 'Upload a template for AI to analyze',
  smartDocDescribeDoc: 'Describe your document requirements',
  smartDocLetAIDraft: 'Let AI help you draft contracts, agreements, etc.',
  smartDocExamples: 'Examples:',
  smartDocExampleRental: '"Help me draft a rental agreement"',
  smartDocExampleLabor: '"Fill in the labor contract based on template"',
  smartDocInputPlaceholder: 'Describe your document needs...',
  smartDocRemoveAttachment: 'Remove attachment',
  smartDocOpenResources: 'Open Resources Panel',
  smartDocExit: 'Exit',
  reviewStartFailed: 'Review workflow start failed',
  reviewFailed: 'Review failed',
  reviewFoundIssues: 'Review complete, found %{count} issues.',
  cannotReadStream: 'Cannot read response stream',
  parseEventFailed: 'Failed to parse workflow event',
  errorPrefix: 'Xəta',
  unknownError: 'Naməlum xəta',
  file: 'Fayl',
  loading: 'Yüklənir...',
  localFolders: 'Local Folders',
  selectLocalFolder: 'Select Local Folder',
  reselectFolder: 'Change Folder',
  addToContext: 'Add to Chat',
  saveFile: 'Save',
  renameFile: 'Rename',
  fileSaved: 'File saved successfully',
  fileRenamed: 'File renamed to %{name}',
  browserNotSupported: 'Your browser does not support local folder access',
  noFolderSelected: 'Select a local folder to browse files',
  scanningFolder: 'Scanning folder...',
  selectFileToPreview: 'Select a file to preview',
  aiAnalyze: 'AI təhlil',
};
